import React, { useEffect, useState } from "react";
import "./Introduction.css";
import { useNavigate } from "react-router-dom";
import TheFounder from "./TheFounder";
import { getAboutContent, getMissionVision, getMilestones } from "../../services/contentService";

const Introduction = () => {
  const [about, setAbout] = useState("");
  const [mission, setMission] = useState("");
  const [vision, setVision] = useState("");
  const [milestones, setMilestones] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    getAboutContent().then(setAbout);
    getMissionVision().then(({ mission, vision }) => {
      setMission(mission);
      setVision(vision);
    });
    getMilestones().then(setMilestones);
  }, []);

  return (
    <div className="intro-page fade-in">
      <TheFounder/>
      <div className="page-header">
        <h1>WHO WE ARE</h1>
      </div>

      <div className="intro-paragraph slide-right">
        <p >{about}</p>
      </div>

      <div className="mission-vision">
        <div className="card slide-left">
          <h2>Mission</h2>
          <p>{mission}</p>
        </div>
        <div className="card slide-right">
          <h2>Vision</h2>
          <p>{vision}</p>
        </div>
      </div>

      <div className="milestones-section">
        <h2 className="slide-left">Our Milestones</h2>
        <div className="milestone-cards">
          {milestones.map((item, idx) => (
            <div className="milestone-card slide-up" key={idx}>
              <div className="milestone-number">{item.Number}</div>
              <div className="milestone-title">{item.Title}</div>
            </div>
          ))}
        </div>
      </div>

      {/* <div className="cta-buttons slide-up">
        <button onClick={() => navigate("/our-work")}>See Our Work</button>
        <button onClick={() => navigate("/about/the-founder")}>Know the Founder</button>
      </div> */}
    </div>
  );
};

export default Introduction;
